import type { FC, SVGProps } from 'react';

/**
 * The panel header's own chrome.
 *
 * Both glyphs exist in atoms/icons already, but only inside a plate that the
 * header cannot use: draggable-icon.svg wraps its arrows in a --white-card-body
 * rounded rect, and minus.jsx wraps its dash in a filled r=10 circle. Dropped
 * onto --purple-50 those plates render as a light square and a filled dot. The
 * path data below is verbatim from those two files, cropped to the glyph and
 * recoloured through currentColor.
 */

/** draggable-icon.svg's arrow cluster, without its card plate. */
export const DragGripGlyph: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="8 8 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <path
      d="M13.6047 10.2674C13.4213 10.4581 13.4272 10.7614 13.6179 10.9448C13.8085 11.1281 14.1118 11.1223 14.2952 10.9316L15.5102 9.67496V15.5292H9.65851L10.7181 14.5087C10.9088 14.3253 10.9147 14.022 10.7313 13.8313C10.5479 13.6407 10.2446 13.6348 10.0539 13.8182L8.13379 15.6679C7.95041 15.8586 7.95629 16.1619 8.14694 16.3452L10.2674 18.3953C10.4581 18.5787 10.7614 18.5728 10.9448 18.3821C11.1282 18.1915 11.1223 17.8882 10.9316 17.7048L9.67498 16.4898H15.5102V22.325L14.2952 21.0684C14.1118 20.8777 13.8085 20.8718 13.6179 21.0552C13.4272 21.2386 13.4213 21.5419 13.6047 21.7326L15.6548 23.8531C15.8381 24.0437 16.1414 24.0496 16.3321 23.8662L18.3953 21.7326C18.5787 21.5419 18.5728 21.2386 18.3821 21.0552C18.1915 20.8718 17.8882 20.8777 17.7048 21.0684L16.4708 22.3448V16.4898H22.325L21.0684 17.7048C20.8777 17.8882 20.8719 18.1915 21.0552 18.3821C21.2386 18.5728 21.5419 18.5787 21.7326 18.3953L23.8531 16.3452C24.0437 16.1619 24.0496 15.8586 23.8662 15.6679L21.7326 13.6047C21.5419 13.4213 21.2386 13.4272 21.0552 13.6179C20.8719 13.8085 20.8777 14.1118 21.0684 14.2952L22.3448 15.5292H16.4708V9.65518L17.7048 10.9316C17.8882 11.1223 18.1915 11.1281 18.3821 10.9448C18.5728 10.7614 18.5787 10.4581 18.3953 10.2674L16.3321 8.13377C16.1414 7.9504 15.8381 7.95627 15.6548 8.14693L13.6047 10.2674Z"
      fill="currentColor"
    />
  </svg>
);

/** minus.jsx's dash, without its filled circle plate. */
export const MinusGlyph: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <path
      d="M4.99918 10H14.9992"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
